import { Injectable } from '@angular/core';
import { HttpMethod } from '@lagoshny/ngx-hateoas-client';
import { map, take } from 'rxjs';
import { Note } from 'src/app/rgs/components/objects/objectItem/objectInspection/models/note.model';
import { RgsHttpErrorResponse } from 'src/app/shared/models/http-error.model';
import { v4 as uuidv4 } from 'uuid';
import { ActionType, CommonState } from '../../../../../shared/services/common-state.service';

@Injectable({
  providedIn: 'root',
})
export class NotesSidebarService extends CommonState<Note> {
  public override items$ = this._items$.asObservable().pipe(
    map((notes) => {
      const sortedNotes = notes.sort((a, b) => {
        if (b?._metadata?.created && a?._metadata?.created) {
          return new Date(b?._metadata?.created)?.getTime() - new Date(a?._metadata?.created)?.getTime();
        }

        return 0;
      });

      const uniqueNotes = [...new Map(sortedNotes.map((note) => [note.id, note])).values()];
      return uniqueNotes;
    }),
  );

  constructor() {
    super(Note);
  }

  public updateItemsValues(notes: Note[]) {
    this._items$.next(notes);
  }

  public findUnreadNotes() {
    const actionId = uuidv4();
    this._loadingItems$.next(true);
    this._action$.next({
      id: actionId,
      type: ActionType.LOAD_ALL,
      status: 'pending',
    });

    this.customSearchQuery<Note[]>(HttpMethod.GET, 'findUnreadNotes')
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this._loadingItems$.next(false);
          this._action$.next({
            id: actionId,
            type: ActionType.LOAD_ALL,
            status: 'success',
          });

          this._items$.next(res);
        },
        error: (err: RgsHttpErrorResponse) => {
          this._loadingItems$.next(false);
          this._action$.next({
            id: actionId,
            type: ActionType.LOAD_ALL,
            status: 'error',
            httpError: err.error,
          });
        },
      });
  }
}
